import { OutgoingCallConfigurationForTheUser } from 'src/models/phoneCall';

import { Callback } from 'src/util/query/models/Callback';

import { SetTheOutgoingCallConfigurationForTheUserPayload } from '../interfaces';

export class GetTheOutgoingCallConfigurationForTheUserQueryCallback extends Callback<OutgoingCallConfigurationForTheUser> {
	public constructor(
		private readonly setOutgoingCallConfigurationForTheUser: (
			payload: SetTheOutgoingCallConfigurationForTheUserPayload
		) => void
	) {
		super();
	}

	failureCallbackFunction = (failureResponse: unknown): void => {
		this.logFailureResponse(failureResponse);
	};

	successCallbackFunction = (successResponse: OutgoingCallConfigurationForTheUser): void => {
		this.setOutgoingCallConfigurationForTheUser({
			outgoingCallConfigurationForTheUser: successResponse,
		});
	};
}
